import { z } from 'zod';

export function getClientInformationFormSchema({
    errorMessages,
    formRules,
}: {
    errorMessages?: { required?: string; costCenter?: { required?: string } };
    formRules?: { costCenter?: { required?: boolean } };
}) {
    return z
        .object({
            organizationId: z.number({
                message: errorMessages?.required,
            }),
            userId: z
                .number({
                    message: errorMessages?.required,
                })
                .positive(),
            constructionProjectId: z
                .string({
                    message: errorMessages?.required,
                })
                .trim()
                .nonempty(),
            projectNumber: z
                .string({
                    message: errorMessages?.required,
                })
                .trim()
                .nonempty(),
            manualCostCenter: z
                .string({
                    message: errorMessages?.required,
                })
                .trim()
                .nullable()
                .transform(val => val || null),
            sourceCostCenter: z.string().nullable().optional(),
        })
        .refine(
            data => !formRules?.costCenter?.required || !!data.sourceCostCenter || !!data.manualCostCenter?.trim(),
            {
                message: errorMessages?.costCenter?.required,
                path: ['manualCostCenter'],
            }
        );
}

export type ClientInformationFormValues = z.input<ReturnType<typeof getClientInformationFormSchema>>;
